<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <section class="section1">
                    <h1 class="">订单流分析工具</h1>
                    <div class="forex-title-intro">
                        通过追踪市场上的实时买卖订单量，分析大机构交易行为，帮助投资者识别主力资金、提高交易胜率，已被高盛、瑞银等华尔街顶级机构采用，成为专业交易者的必备工具。
                    </div>
                    <div class="forex-title-tips">账户净值大于$ 50,000免费申请</div>
                    <div class="forex-btn-group">
                        <ebc-btn class="ebc-btn">申请开通订单流</ebc-btn>
                    </div>
                </section>
                <section class="section2">
                    <h2 class="">订单流基础教程</h2>
                    <div class="swiper document-list-wrapper1">
                            <swiper ref="swiperBasic" :options="swiperBasicOptions" class="document-list">
                                <swiper-slide v-for="(vo,index) in basicList" :key="index">
                                    <div class="document-item">
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                            <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                        </a>
                                        <div>
                                            <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                                vo.post_title }}</a>
                                            <div class="document-btn-text">
                                                {{ formateTime(vo.published_time) }}
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                    </div>
                </section>
                <section class="section3">
                    <h2 class="">订单流相关问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">
                                1. 什么是订单流？适合什么类型的交易者？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    订单流是一种基于市场真实成交数据（如成交量、挂单、主动买卖）进行分析的交易方式。适合中短线交易者、日内交易者及高频交易者，用于捕捉市场微观结构和情绪变化。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">2. 订单流和传统技术分析有什么区别？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    传统技术分析主要基于价格走势和图表形态，而订单流则专注于实时成交行为和买卖力量的动态关系。订单流可揭示市场“幕后力量”，在重要价位判断更具优势。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">
                                3. 使用订单流是否需要特殊软件或专业知识？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    是的。订单流分析通常依赖专业工具（如 DOM、Footprint
                                    图等），并需要对市场微结构、盘口语言有深入理解。初学者建议结合模拟账户进行训练，并参考教学资源。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">4. 如何通过订单流判断突破是否真实？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    观察关键价位的买卖量配比、主动成交方向与跟单行为，如果突破时配合强劲主动买单且无大量反向吸收单，通常更具持续性。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5. EBC提供的订单流工具有哪些功能？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC平台订单流工具提供实时盘口数据、挂单/成交分布、买卖力度热力图等功能，帮助交易者掌握关键价格行为并制定更精准的交易策略。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">6. 订单流适用于哪些市场品种？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    订单流主要应用于流动性充足的市场，如外汇、黄金、原油、美股CFD等。在这些市场中，订单驱动性强，订单流分析能有效发挥作用。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getOrderFlowTutorial } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide
    },
    data() {
        return {
            basicList: [],
            advancedList: [],
            swiperBasicOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
            swiperAdvancedOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
        }
    },
    created() {
        getOrderFlowTutorial().then(response => {
            if (response.status && response.status == '200') {
                this.basicList = response.data.data.basic
                this.advancedList = response.data.data.advanced
            }

        }).catch(err => {
            this.basicList = []
            this.advancedList = []
        })
    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    },
     mounted() {
        
            // 获取所有的QA-item元素
            var qaItems = document.querySelectorAll(".QA-item");
            

            // 遍历每个QA-item，为其添加点击事件监听器
            qaItems.forEach(function (item) {
                item.addEventListener("click", function () {
                    // 获取当前点击的QA-content元素
                    var content = this.querySelector(".QA-content");
                     console.log("!!!!!!!!!22222!!")

                    // 如果点击的QA-content是隐藏的，则展示它；反之则隐藏
                    if (content.style.display === "none" || content.style.display === "") {
                        // 移除所有其他QA-item上的.QA-actived类，并隐藏其QA-content
                        qaItems.forEach(function (otherItem) {
                            otherItem.querySelector(".QA-content").style.display = "none";
                            otherItem.classList.remove("QA-actived");
                        });

                        // 展示当前点击的QA-content，并为当前QA-item添加.QA-actived类
                        content.style.display = "block";
                        this.classList.add("QA-actived");
                    } else {
                        // 如果已经是显示状态，则隐藏并移除.QA-actived类
                        content.style.display = "none";
                        this.classList.remove("QA-actived");
                    }
                });
            });
    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>